import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  TextField,
  DialogTitle,
  Tooltip
} from "@material-ui/core";
import { useDispatch } from "react-redux";
import { PatientActions } from '../../redux/actions/PatientActions';

const useStyles = makeStyles((theme) => ({
  typography: {
    padding: theme.spacing(2),
  },
  cancelButton: {
    color: "#dd4b39",
    margin: theme.spacing(1),
  },
}));

const AppointmentCancelConfirmation = (props) => {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [message, setMessage] = React.useState('');
  const dispatch = useDispatch();

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  const id = open ? "cancel-popover" : undefined;

  return (
    <>
      <Box display="flex" justifyContent="flex-end">
      <Tooltip title="Send message to patient" arrow>
        <div
          variant="rounded"
          aria-describedby={id}
          className={classes.cancelButton}
          onClick={handleClick}
        >
          <i className="fas fa-sms"></i>
        </div>
        </Tooltip>
      </Box>
      
      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth={'sm'}
        fullWidth={true}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title">
          {"Send message to patient"}
        </DialogTitle>
        <DialogContent>
        <TextField
            autoFocus
            margin="dense"
            id="name"
            multiline
            rowsMax={4}
            label="Message"
            type="message"
            onChange={(e)=>{setMessage(e.target.value)}}
            fullWidth
          />
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={handleClose} color="primary">
            Cancel
          </Button>
          <Button
            onClick={() => {
              if(message && props.id && message.length > 0 && props.id.length > 0){
                var payload ={
                  "patientId": [props.id],
                  "message": message
                }
                dispatch(PatientActions.sendPatientSMS(payload));
                handleClose();  
              }
              
            }}
            color="secondary"
            autoFocus
          >
            Send
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default AppointmentCancelConfirmation;
